import {CategoryTreeItem, FlatCategoryTreeItem} from "./data";

export const flattenCategoryTree = (tree: CategoryTreeItem[], depth: number = 0): FlatCategoryTreeItem[] => {
	let accumulator = [] as FlatCategoryTreeItem[]
	return tree.reduce((acc, v) => {
		acc = acc.concat([{...v, depth: depth}])
		if(v.children !== undefined) {
			acc = acc.concat(flattenCategoryTree(v.children, depth+1))
		}
		return acc
	}, accumulator)
}



// WEBPACK FOOTER //
// ./src/lib/category-manager/utils.ts